import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import Context from '../../../context';

//@TODO: Commented code is not used anymore confirm with jnj repository
const Look = ({
  selected,
  look,
  recommended,
  recommendedStar,
  language,
  onClick,
}) => {
  const { looksCleared } = useContext(Context);
  const getClass = () => {
    let className = [];
    if (looksCleared) return '';
    if (recommended) className.push('recommended');
    if (selected) className.push('active');
    return className.join(' ');
  };

  return (
    <li onClick={() => onClick(look)} className={`palette--item${getClass()}`}>
      {/* {selected  && !looksCleared && ( */}
      <span className="palette--item__name">{look[language].name}</span>
      {/* )} */}
      {/* <div className='look-image'>
        <img className='img-responsive icon' src={recommendedStar} />
        <img className='img-responsive' src={imageSet[look.icon]} />
      </div> */}
    </li>
  );
};

Look.propType = {
  index: PropTypes.number,
  selected: PropTypes.number,
  look: PropTypes.shape({
    az: PropTypes.shape({
      name: PropTypes.string,
    }),
    en: PropTypes.shape({
      name: PropTypes.string,
    }),
    hk: PropTypes.shape({
      name: PropTypes.string,
    }),
    id: PropTypes.shape({
      name: PropTypes.string,
    }),
    ja: PropTypes.shape({
      name: PropTypes.string,
    }),
    vi: PropTypes.shape({
      name: PropTypes.string,
    }),
    fil: PropTypes.shape({
      name: PropTypes.string,
    }),
    ko: PropTypes.shape({
      name: PropTypes.string,
    }),
    my: PropTypes.shape({
      name: PropTypes.string,
    }),
    sg: PropTypes.shape({
      name: PropTypes.string,
    }),
    th: PropTypes.shape({
      name: PropTypes.string,
    }),
    twq: PropTypes.shape({
      name: PropTypes.string,
    }),
    zh: PropTypes.shape({
      name: PropTypes.string,
    }),
    ar: PropTypes.shape({
      name: PropTypes.string,
    }),
    arabia_en: PropTypes.shape({
      name: PropTypes.string,
    }),
    ru: PropTypes.shape({
      name: PropTypes.string,
    }),
    icon: PropTypes.string,
    lens: PropTypes.string,
    guid: PropTypes.string,
    lensOrder: PropTypes.number,
  }),
  recommended: PropTypes.string,
  recommendedStar: PropTypes.string,
  language: PropTypes.string,
  onClick: PropTypes.func,
};

export default Look;
